import React from "react";

const Sprite = ({ src, x = 0, y = 0, scale=1, width, height, backgroundWidth, backgroundHeight,contain, cover, pixelated, style, ...rest }) => {
  if (!src) {
    return null;
  }

  const spriteStyle = {
    backgroundImage: `url(${src})`,
    backgroundPosition: `${x * scale * -1}px ${y * scale * -1}px`,
    backgroundRepeat: "no-repeat",
    width: `${width ? (width * scale)+'px' : undefined}`,
    height: `${height ? (height * scale)+'px' : undefined}`,
    imageRendering: pixelated ? "pixelated" : undefined,
    backgroundSize: contain ? 'contain': cover ? 'cover' : `${backgroundWidth * scale}px ${backgroundHeight * scale}px`,
    ...(style || {})
  };

  return <div style={spriteStyle} {...rest}/>;
};

export default Sprite;
